import { render, staticRenderFns } from "./Assemble.vue?vue&type=template&id=826e96e0&scoped=true&"
import script from "./Assemble.vue?vue&type=script&lang=js&"
export * from "./Assemble.vue?vue&type=script&lang=js&"
import style0 from "./Assemble.vue?vue&type=style&index=0&id=826e96e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826e96e0",
  null
  
)

export default component.exports